<script>
    export default {
        name: "Rule"
    }
</script>

<template>
    <div class="wh100">
        <!-- <img src="../../assets/img/Rule.png" alt=""> -->
        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-10-30/ruleBanner.png" alt="">
    </div>
</template>

<style scoped lang="less">
    .wh100 {
        width: 100%;
        //height: 100%;
        padding: 50px 30px 0 30px;

        //height: 100%;
        img {
            width: 100%;
            height: 100%;
        }
    }
</style>